/**
 * App Open Interval Trigger Component
 *
 * Trigger: "opened the app (interval)"
 * No additional fields needed - timing is handled at card level.
 */

import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { TriggerComponentProps } from '../automationTriggers';

export const AppOpenIntervalTrigger: FC<TriggerComponentProps> = ({
  readOnly,
}) => {
  const { t } = useTranslation();

  if (readOnly) {
    return <span>{t('automations.triggers.openedAppInterval')}</span>;
  }

  // Edit mode - no additional fields, timing handled at card level
  return null;
};
